<template>
  <div class="dingTalk" @click="handleTripleClick">
    <pre class="log-display" v-if="showVConsole">{{ logDisplay }}</pre>
    <img style="width: 50px" v-if="this.loadingStatus == 0" src="../../assets/images/loading.gif" alt="" />
    <div v-else-if="this.loadingStatus == 1" style="font-size: 24px;">{{ this.approvalClass.errorMessage }}</div>
  </div>
</template>

<script>
import DingTalkApprovalClass from './dingtalkApprovalClass';
import VConsole from '@/utils/vconsole.min.js'

export default {
  name: 'DingTalkAuth',
  data() {
    return {
      approvalClass: new DingTalkApprovalClass(),
      logDisplay: '', // 添加响应式数据来显示log值
      clickTimes: 0, // 记录点击次数
      lastClickTime: 0, // 上次点击时间
      showVConsole: false,
      loadingStatus: 0,
    };
  },
  watch: {
    // 监听approvalClass.log的变化
    'approvalClass.log': {
      handler(newVal) {
        this.logDisplay = `code = ${newVal}`;
      },
      immediate: true
    },
    'approvalClass.loadingStatus': {
      handler(newVal) {
        this.loadingStatus = newVal;
      },
      immediate: true
    }
  },
  mounted() {
    // 从localStorage检查是否需要显示vConsole并初始化
    if (localStorage.getItem('showVConsole') === '1') {
      this.initVConsole();
    }
    console.log('mounted');
    this.addMetaTag();
    this.initDingtalkRemoteMonitor();
    this.approvalClass.startAuthAndLogin();

  },
  methods: {
    // 处理三连击事件
    handleTripleClick() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastClickTime > 1000) { // 如果距离上次点击超过1秒，则重置计数
        this.clickTimes = 0;
      }
      
      this.clickTimes++;
      this.lastClickTime = currentTime;
      
      if (this.clickTimes >= 3) {
        this.clickTimes = 0; // 重置计数
        this.switchShowVConsole(); // 调用切换VConsole的方法
      }
    },

    // 切换VConsole显示状态
    switchShowVConsole() {
      let currentValue = localStorage.getItem('showVConsole');
      if (currentValue === '1') {
        localStorage.setItem('showVConsole', '0');
        this.showVConsole = false;
        // 如果VConsole实例存在，则销毁它
        if (window.vConsoleInstance) {
          window.vConsoleInstance.destroy();
          window.vConsoleInstance = null;
        }
      } else {
        localStorage.setItem('showVConsole', '1');
        // 初始化VConsole
        this.initVConsole();
      }
    },

    // shouldShowVConsole() {
    //   let currentValue = localStorage.getItem('showVConsole');
    //   return currentValue === '1';
    // },

    // 初始化VConsole
    initVConsole() {
      // 检查是否已经初始化了VConsole实例
      if (!window.vConsoleInstance) {
        this.showVConsole = true;
        window.vConsoleInstance = new VConsole();
      }
    },

    addMetaTag() {
      // 页面加载时动态添加meta标签
      const meta = document.createElement('meta');
      meta.name = 'wpk-bid';
      meta.content = 'dta_2_143598';
      document.head.appendChild(meta);
    },
  
    // 初始化木犀监控
    initDingtalkRemoteMonitor() {
      const isDingtalk = navigator && /DingTalk/.test(navigator.userAgent);
      const isProductEnv = window && window.location && window.location.host
        && window.location.host.indexOf('127.0.0.1') === -1
        && window.location.host.indexOf('localhost') === -1
        && window.location.host.indexOf('192.168.') === -1;
      // 如果有其它测试域名，请一起排掉，减少测试环境对生产环境监控的干扰
      if (isProductEnv) {
        !(function (c, i, e, b) {
          var h = i.createElement("script");
          var f = i.getElementsByTagName("script")[0];
          h.type = "text/javascript";
          h.crossorigin = true;
          h.onload = function () {
            c[b] || (c[b] = new c.wpkReporter({ bid: "dta_2_143598" }));
            c[b].installAll()
          };
          f.parentNode.insertBefore(h, f);
          h.src = e
        })(window, document, "https://g.alicdn.com/woodpeckerx/jssdk??wpkReporter.js", "__wpk");
      }
    },
  },
};
</script>

<style scoped>
.log-display {
  white-space: pre-wrap;       /* 保留空白符序列，但是正常地进行换行 */
  word-wrap: break-word;       /* 在长单词或URL地址内部进行换行 */
  font-family: monospace;      /* 使用等宽字体显示日志 */
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 400px;
  max-height: 400px;
  overflow-y: auto;
}

.dingTalk {
  display: flex;
  flex-direction:  column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
```